export var parsePageFilter = function (page) {
    var pageNumber = Number(page);
    if (Number.isNaN(pageNumber))
        return 1;
    return Math.max(pageNumber, 1);
};
//# sourceMappingURL=parse-page-filter.js.map